import React from "react";
import { useNavigate } from "react-router-dom";

const BreadCrumbs = ({ breadcrumbs }) => {
  const navigate = useNavigate();
  return (
    <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
      <li className="inline-flex items-center">
        <span
          onClick={() => navigate("/Providers")}
          className="cursor-pointer inline-flex items-center text-[0.857rem] font-medium text-[rgb(107,114,128)] hover:text-gray-700"
        >
          Vendors
        </span>
        <svg
          className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 9 4-4-4-4"
          />
        </svg>
      </li>

      {/* Second breadcrumb (Dynamic Name from `data.name`) */}
      <li className="inline-flex items-center">
        <a
          href={"#"} // Adjust the href based on your logic
          className="inline-flex items-center text-[0.857rem] font-medium text-[rgb(107,114,128)]"
        >
          {breadcrumbs?.name} {/* Display data.name */}
        </a>
      </li>
    </ol>
  );
};

export default BreadCrumbs;
